/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { B200, B300, B400, B50, N10, N100, N20, N30, N70, N80, N900, R300 } from '@atlaskit/theme/colors';
var baseStyles = css({
  display: 'grid',
  gridAutoColumns: '1fr',
  gridAutoRows: 'min-content',
  color: "var(--ds-text, ".concat(N900, ")"),
  cursor: 'default',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var textLabelLayoutStyles = css({
  gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
  gridTemplateColumns: 'min-content auto'
});
var disabledStyles = css({
  color: "var(--ds-text-disabled, ".concat(N80, ")"),
  cursor: 'not-allowed'
});
var labelStyles = css({
  /**
   * Background
   */
  '--local-background': "var(--ds-background-input, ".concat(N10, ")"),
  '--local-background-active': "var(--ds-background-input-pressed, ".concat(B50, ")"),
  '--local-background-checked': "var(--ds-background-selected-bold, ".concat(B400, ")"),
  '--local-background-checked-hover': "var(--ds-background-selected-bold-hovered, ".concat(B300, ")"),
  '--local-background-disabled': "var(--ds-background-disabled, ".concat(N20, ")"),
  '--local-background-hover': "var(--ds-background-input-hovered, ".concat(N30, ")"),
  /**
   * Border
   */
  '--local-border': "var(--ds-border-input, ".concat(N100, ")"),
  '--local-border-active': "var(--ds-border, ".concat(B50, ")"),
  '--local-border-checked': "var(--ds-background-selected-bold, ".concat(B400, ")"),
  '--local-border-checked-hover': "var(--ds-background-selected-bold-hovered, ".concat(B300, ")"),
  '--local-border-checked-invalid': "var(--ds-border-danger, ".concat(R300, ")"),
  '--local-border-disabled': "var(--ds-background-disabled, ".concat(N20, ")"),
  '--local-border-focus': "var(--ds-border-focused, ".concat(B200, ")"),
  '--local-border-hover': "var(--ds-border-input, ".concat(N100, ")"),
  '--local-border-invalid': "var(--ds-border-danger, ".concat(R300, ")"),
  /**
   * Tick
   */
  '--local-tick-active': "var(--ds-icon-inverse, ".concat(B400, ")"),
  '--local-tick-checked': "var(--ds-icon-inverse, ".concat(N10, ")"),
  '--local-tick-disabled': "var(--ds-icon-disabled, ".concat(N70, ")"),
  '--local-tick-rest': 'transparent'
});
export default function Label(_ref) {
  var children = _ref.children,
    isDisabled = _ref.isDisabled,
    testId = _ref.testId,
    label = _ref.label,
    id = _ref.id;
  return jsx("label", {
    css: [baseStyles, label && textLabelLayoutStyles, isDisabled && disabledStyles, labelStyles],
    "data-testid": testId,
    "data-disabled": isDisabled || undefined,
    id: id
  }, children);
}